import React from "react";
import PropTypes from "prop-types";

function Radio({ id, name, value, isSelected, handleSelection, children }) {
  return (
    <label className="tw-my-0 tw-flex tw-items-center" htmlFor={id}>
      <input
        type="radio"
        id={id}
        value={value}
        name={name}
        onChange={handleSelection}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleSelection(e);
        }}
        checked={isSelected}
      />
      <span className="tw-mx-2">{children}</span>
    </label>
  );
}

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleSelection: PropTypes.func.isRequired,
};

export default Radio;
